import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { apiFetch } from '../lib/api';
import { useAuth } from '../context/AuthContext';

const useAppBootstrap = ({ clearSavedAlumniData, resetSearchState, resetEmailDrafts }) => {
  const navigate = useNavigate();
  const { logout, closeEmailAuthModal, setFullName, setUserBio } = useAuth();

  const testBackend = useCallback(async () => {
    try {
      const response = await apiFetch(`/health`);
      if (response.ok) {
        await response.text();
      }
    } catch (error) {
      console.error('❌ Backend health check failed:', error);
    }
  }, []);

  const forceSignOut = useCallback(async () => {
    setFullName('');
    setUserBio('');
    clearSavedAlumniData?.();
    closeEmailAuthModal();
    resetSearchState?.();
    resetEmailDrafts?.();
    navigate('/');
    await logout();
  }, [clearSavedAlumniData, closeEmailAuthModal, logout, navigate, resetEmailDrafts, resetSearchState, setFullName, setUserBio]);

  return {
    testBackend,
    forceSignOut,
  };
};

export { useAppBootstrap };
